import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const FormObserver = ({ dispatcher }) => {
  const { values } = useFormikContext()
  const dispatch = useDispatch()
  // const props = useFormikContext()
  // console.log(props)

  // const { errors } = useFormikContext()
  // console.log(errors)
  // console.log({ touched, errors })

  useEffect(() => {
    console.log(values)
    if (!dispatcher) return
    dispatch(dispatcher(values))
  }, [values, dispatch, dispatcher])

  return null
}

export default FormObserver
